import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { TenantTokenUsageListStore } from "../../store/TenantTokenUsageListStore";

type TenantTokenUsageListDialogsProps = {
  store: TenantTokenUsageListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de TenantTokenUsage.
 * Separado para mantener TenantTokenUsageListPage más limpio.
 */
export const TenantTokenUsageListDialogs: React.FC<TenantTokenUsageListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
